module.exports = __webpack_public_path__ + "static/media/c2bannerModulF_small.a27628ef.jpg";